@if (dialogData) {
    <main
        #modalContainer
        id="modal-container"
        class="flex flex-col bg-white items-center theme-wrapper overflow-y-auto md:h-fit max-h-screen rounded-xl min-w-[20rem] min-h-[10rem] md:w-[400px] relative"
        (scroll)="onScroll($event)"
    >
        <header
            class="flex sticky top-0 z-10 flex-col gap-3 items-center p-4 w-full theme-wrapper"
        >
            <app-icon
                [name]="iconName()"
                [color]="iconColor()"
                [ngClass]="iconClass()"
                size="lg"
            />
            <h1 class="text-xl font-semibold theme-text">
                {{ dialogData.title }}
            </h1>
        </header>

        @if (dialogData.data) {
            <div
                class="flex flex-col gap-3 px-4 py-3 mb-6 w-full border-gray-200 border-y"
            >
                @for (data of dialogData.data; track $index) {
                    <div class="flex gap-2 justify-between items-start">
                        @if (data.key) {
                            <span
                                class="min-w-[5rem] text-sm text-gray-500 break-all"
                                >{{ data.key }}</span
                            >
                        }
                        @if (data.value) {
                            <span
                                [class]="data?.badgeProps?.class"
                                class="text-sm break-all"
                                >{{ data.value }}</span
                            >
                        }
                    </div>
                }
            </div>
        }

        @if (dialogData.inputs) {
            <form
                [formGroup]="form!"
                class="flex flex-col gap-3 px-4 mb-6 w-full"
            >
                @for (input of dialogData.inputs; track $index) {
                    @if (input.type !== "textarea") {
                        <app-input
                            [formControlName]="input.key"
                            class="w-full"
                            [label]="input.label"
                            [type]="input.type"
                            [placeholder]="input.placeholder ?? ''"
                            [value]="input.defaultValue"
                        />
                    } @else {
                        <app-textarea
                            [formControlName]="input.key"
                            class="w-full"
                            [label]="input.label"
                            [placeholder]="input.placeholder ?? ''"
                            [value]="input.defaultValue"
                        />
                    }
                }
            </form>
        }

        @if (dialogData.content) {
            <section
                class="flex justify-center items-center basis-full grow-0 md:basis-0"
            >
                @if (!dialogData.markdown) {
                    <div
                        class="text-gray-600 px-4 max-h-full font-medium text-center whitespace-pre-line text-pretty"
                        [innerHTML]="dialogData.content"
                    ></div>
                } @else {
                    <markdown
                        class="px-4 basis-full grow-0"
                        [data]="dialogData.content"
                    />
                }
            </section>
        }

        @if (dialogData.term) {
            <p
                (click)="openTermModal()"
                class="mt-6 text-sm text-center text-gray-500 underline cursor-pointer select-none underline-offset-4"
            >
                {{ dialogData.term.text }} >
            </p>
        }

        @if (dialogData.checkbox) {
            <div class="px-4 w-full">
                <div
                    [class.bg-primary-50]="checked()"
                    class="px-3 py-2.5 mt-6 w-full rounded-xl border border-gray-100 transition-colors"
                >
                    <app-checkbox
                        size="sm"
                        [label]="dialogData.checkbox.text"
                        [(value)]="checked"
                    />
                </div>
            </div>
        }

        @if (dialogData.hints) {
            <div class="flex flex-col gap-2 px-4 mt-6">
                @for (hint of dialogData.hints; track $index) {
                    <div
                        class="flex gap-2.5 items-start px-4 py-3 bg-gray-50 rounded-2xl"
                    >
                        <app-icon
                            name="solar:info-circle-bold-duotone"
                            class="text-gray-300 !size-5 min-w-5"
                        />
                        <p class="text-sm text-gray-500">{{ hint }}</p>
                    </div>
                }
            </div>
        }

        <footer
            class="flex sticky bottom-0 z-10 gap-3 p-4 mt-6 w-full border-t theme-wrapper theme-border"
        >
            @if (!dialogData.buttons?.cancel?.hidden) {
                <app-button
                    class="flex-1"
                    expand
                    variant="outline"
                    [color]="dialogData.buttons?.cancel?.color ?? 'white'"
                    (click)="onCancel()"
                    >{{
                        dialogData.buttons?.cancel?.text ?? "취소"
                    }}</app-button
                >
            }

            @if (dialogData.buttons?.confirm?.hidden !== true) {
                <app-button
                    class="flex-1"
                    expand
                    [color]="dialogData.buttons?.confirm?.color ?? 'primary'"
                    (click)="onConfirm()"
                    [disabled]="(!!form && form.invalid) || checkInvalid()"
                    >{{
                        dialogData.buttons?.confirm?.text ?? "확인"
                    }}</app-button
                >
            }
        </footer>
    </main>
}
